var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './EmptyState.module.scss';
var EmptyState = function (_a) {
    var title = _a.title, icon = _a.icon, dataId = _a.dataId;
    return (_jsx("div", __assign({ className: "".concat(styles.EmptyState), "data-testid": dataId }, { children: _jsxs("div", { children: [_jsx("div", __assign({ className: styles.Image }, { children: icon })), _jsx("p", __assign({ className: styles.Text }, { children: title }))] }) })));
};
EmptyState.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,
    dataId: PropTypes.string,
};
export { EmptyState };
//# sourceMappingURL=EmptyState.js.map